import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Segment, Header, Button } from "semantic-ui-react";
import DocumentUploader from "./adjuntarDocumentacion/DocumentUploader";
import { documentacionOps } from "../ducks/documentacion";
import SearchField from "./shared/SearchField";
import isEmpty from "lodash/isEmpty";

class AdjuntarDocumentacion extends Component {
  state = { resguardo: null };

  componentDidMount() {
    this.props.colegioSeleccionado === null
      ? this.props.history.push("/inscripciones")
      : this.props.cargarDatosColegio(this.props.colegioSeleccionado);
  }

  componentWillUnmount() {
    this.props.limpiarColegioSeleccionado();
    this.props.resetDetalleColegio();
  }

  handleBuscarResguardo = (e, { busqueda }) =>
    this.setState(state => ({
      resguardo: isEmpty(busqueda) ? null : busqueda
    }));

  handleClickInfo = () =>
    this.setState(state => ({
      resguardo: null
    }));

  handleUploadFile = file => {
    this.props.clearUploadComplete();
    this.props.uploadFile({
      file,
      resguardo: this.state.resguardo,
      idColegio: this.props.colegioSeleccionado
    });
  };

  clickVolver = () => this.props.history.push("/inscripciones");

  render() {
    return (
      <Container>
        <Segment basic>
          <Segment textAlign="center">
            <Button
              floated="right"
              content="Volver"
              onClick={this.clickVolver}
              color="pink"
              icon="left arrow"
            />
            <Header>
              {this.props.detalleColegio &&
                `Adjuntar documentos para la Escuela de Verano de ${
                  this.props.detalleColegio.nombre
                }`}
            </Header>
          </Segment>

          {!this.state.resguardo && (
            <Segment textAlign="center">
              <SearchField
                form="SearchResguardosPreForm"
                fieldID="buscarResguardo"
                fieldName="busqueda"
                labelText="Introduzca el número de Resguardo"
                placeholder=""
                handleButtonClick={this.handleBuscarResguardo}
                datosBusqueda={this.props.listaResguardos}
              />
            </Segment>
          )}
          {this.state.resguardo && (
            <Segment padded>
              <Button
                color="pink"
                icon="cancel"
                content="cerrar"
                onClick={this.handleClickInfo}
                floated="right"
              />
              <Header>
                Seleccione el fichero que desee adjuntar. Luego pulse el botón
                "Adjuntar fichero" para enviarlo.
              </Header>
              <Header as="h3">Formatos admitidos: jpg, jpeg, png, pdf, txt</Header>
              <DocumentUploader
                handleUploadFile={this.handleUploadFile}
                procesoEnvio={this.props.procesoEnvio}
                uploadComplete={this.props.uploadComplete}
              />
            </Segment>
          )}
        </Segment>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  colegioSeleccionado: state.documentacion.colegioSeleccionado,
  detalleColegio: state.documentacion.detalleColegio,
  listaResguardos: state.documentacion.listaResguardos,
  procesoEnvio: state.documentacion.procesoEnvio,
  uploadComplete: state.documentacion.uploadComplete
});

const mapDispatchToProps = {
  limpiarColegioSeleccionado: documentacionOps.limpiarColegioSeleccionado,
  cargarDatosColegio: documentacionOps.cargarDatosColegio,
  resetDetalleColegio: documentacionOps.resetDetalleColegio,
  uploadFile: documentacionOps.uploadFile,
  clearUploadComplete: documentacionOps.clearUploadComplete
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdjuntarDocumentacion);



// WEBPACK FOOTER //
// ./src/pages/AdjuntarDocumentacion.jsx